import React from 'react';
import { Paper, Typography } from '@mui/material';
import { Contractor } from '../../../types';

interface ContractorInvoicesSectionProps {
  contractor: Contractor;
}

const ContractorInvoicesSection: React.FC<ContractorInvoicesSectionProps> = ({ contractor }) => {
  return (
    <Paper sx={{ p: 3 }}>
      <Typography variant="h6" gutterBottom>
        Invoices & Payment Tracking
      </Typography>
      <Typography variant="body2" color="text.secondary">
        Invoices and payments for {contractor.name} will be displayed here.
      </Typography>
    </Paper>
  );
};

export default ContractorInvoicesSection;
